import { Link } from 'react-router';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './Page.css';

export function NotFound() {
  useDocumentTitle('Off the trail');
  return (
    <div className="page-page">
      <h1>Off the trail</h1>
      <p>This page does not exist.</p>
      <Link to="/" className="btn">
        Back home
      </Link>
    </div>
  );
}
